import React, { ReactElement, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import {
  Checkbox, Row, Button, Spin,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/pro-light-svg-icons';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import {
  getPaciente,
  getPacienteRGPD,
  setPacienteRGPDCondition,
  setPacienteRGPDConditions,
} from '../../../../state/actions/creators/pacientes.actioncreator';
import { ROUTE_PACIENTES_FILE, ROUTE_PACIENTES_GDPR_SIGN } from '../../../../routes.constants';
import gdprPrint from '../../components/gdpr/gdprPrint';
import Page from "../../../shared/components/layout/Page.layout";
import {
  Text,
} from '../../../shared/components';
interface gdprProps {
  intl: any
}

function GDPR({ intl }:gdprProps) {
  const { pacienteId }: any = useParams();
  const history = useHistory();
  const { pacienteSelected, grpd } = useSelector((state: any) => state.pacientesWorkspace);
  const { condiciones, condiciones_adicionales } = grpd;
  const sagas = useSelector((state: any) => state.sagas);
  const cancelPath = generatePath(ROUTE_PACIENTES_FILE, { pacienteId });
  const deviceMobile = isMobile;
  const tiendaId = useSelector((state: any) => state.auth.user.user_info.tienda_id);

  const dispatch = useDispatch();
  useEffect(() => {
    if (!pacienteSelected) {
      dispatch(getPaciente({ tiendaId, pacienteId }));
    }
    dispatch(getPacienteRGPD({
      pacienteId,
    }));
  }, []);


  const acceptGDPR = () => {
    dispatch(setPacienteRGPDConditions({
      condiciones,
      condicionesAdicionales: condiciones_adicionales,
    }));
    history.push(generatePath(ROUTE_PACIENTES_GDPR_SIGN, { pacienteId }));
  };

  const gdpr: ReactElement = (
    <div className="patient-gdpr">
      <div className="container_gdpr">
        <h3>{intl.formatMessage({ id: 'pacientes.gdpr.conditions' })}</h3>
        <div className="conditions">
          <p>{condiciones}</p>
        </div>
      </div>
      <div className="container_gdpr">
        <h3>{intl.formatMessage({ id: 'pacientes.gdpr.add_conditions' })}</h3>
        <div className="additional flexCol">
          {condiciones_adicionales && condiciones_adicionales.map((condicion: any) => (
            <Row key={condicion.identificador}>

              <Checkbox
                onClick={(event: any) => {
                  dispatch(setPacienteRGPDCondition({
                    identificador: condicion.identificador,
                    valor: event.target.checked,
                  }));
                }}
                checked={condicion.valor}
              >
                {condicion.descripcion_larga ? condicion.descripcion_larga : condicion.descripcion}
              </Checkbox>
            </Row>
          ))}
        </div>
      </div>
      <div className="footer_gdpr">
        {deviceMobile
          ? <div />
          : (
            <div className="flexRow">
              <p className="blueLink" style={{ marginRight: 8 }}><FontAwesomeIcon icon={faPrint} /></p>
              <p
                className="blueLink"
                onClick={() => gdprPrint(condiciones, condiciones_adicionales,
                  intl.formatMessage({ id: 'pacientes.client_file.gdpr' }))}
              >
                {intl.formatMessage({ id: 'pacientes.gdpr.print' })}
              </p>
            </div>
          )
        }
        <div className="flexRow flexEnd">
          <Button
            onClick={() => history.push(cancelPath)}
            size="large"
          >
            {intl.formatMessage({ id: 'pacientes.signGDPR.cancel' })}
          </Button>
          <Button
            size="large"
            type="primary"
            style={{ marginLeft: '10px' }}
            onClick={acceptGDPR}
          >
            {deviceMobile
              ? intl.formatMessage({ id: 'pacientes.gdpr.i_accept' })
              : intl.formatMessage({ id: 'pacientes.gdpr.accept_conditions' })
            }
          </Button>
        </div>
      </div>
    </div>
  );
  const loadingPage = !pacienteSelected || sagas.PACIENTES_GET_PACIENTE_RGPD?.running;
  return (
    <Page
      titulo={pacienteSelected ? pacienteSelected.nombre_completo : `Ficha (${pacienteId})`}
      navigationItems={[
        {
          node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.home" />,
          link: '',
        },
        {
          node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.pacientes" />,
          link: '/pacientes/buscar',
        },
        {
          node: <Text upperCase={false} lowerCase={false} translationId={null}>{pacienteSelected ? pacienteSelected.nombre_completo : `Ficha (${pacienteId})`}</Text>,
          link: `/pacientes/file/${pacienteId}`,
        },
      ]}
      loading={loadingPage}
    >
      <div className="patient patient-gdpr">
        {gdpr}
      </div>
    </Page>
  );
}

export default injectIntl(GDPR);
